const liquidacionesRoutes = [
  {
    path: "/liquidaciones",
    name: "liquidaciones",
    component: () => import(/* webpackChunkName: "liquidaciones-page" */ "@/modules/liquidaciones/views/LiquidacionesPage.vue"),
  },
];

export default liquidacionesRoutes;
